export enum Alimentation {
	Breast = 0,
	Milk = 1,
	Both = 2
}